@if (Site) {
  <div class="container-fluid h-100 d-flex flex-column">
    <div class="row">
      <div class="col">
        <h2>Site - {{ Site.legalName }}</h2>
      </div>
    </div>
    <div class="row flex-grow-1 mb-3">
      <div class="col">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
}
